/**
 * Belge filtreleme metodlarını oluşturur
 *
 * @param {Object} state - Uygulama state
 * @param {Object} services - Servisler
 * @returns {Object} Belge filtreleme metodları
 */
export const createDocumentFilterMethods = (state, services) => {
  const {
    filters,
    searchQuery,
    showFilters,
    isFilterLoading,
  } = state

  /**
   * Filtreleri uygula ve belgeleri yenile
   * @param {Function} filterDocuments - Belgeleri filtreleme fonksiyonu (dependency injection)
   */
  const applyFilters = (filterDocuments) => {
    // Filtreleme işlemini başlat
    isFilterLoading.value = true

    // Panel görünürlüğünü kapat
    showFilters.value = false

    // Kısa bir gecikme ekleyerek loading animasyonunun görünmesini sağla
    setTimeout(() => {
      // tüm belgeleri yeniden filtrele
      if (typeof filterDocuments === 'function') {
        filterDocuments()
      }

      // Filtreleme işlemi tamamlandı
      isFilterLoading.value = false
    }, 300) // 300ms gecikme ekliyoruz, bu süre animasyonun görünmesini sağlayacak
  }

  /**
   * Tüm filtreleri sıfırla
   */
  const resetFilters = () => {
    filters.fileType = null
    filters.categoryIds = []
    filters.dateFilter = null
    searchQuery.value = ''

    // Asıl applyFilters metodunu burada çağırmıyoruz, onu kullanıcı kodu çağıracak
  }

  /**
   * Belirli bir filtreyi kaldır
   * @param {String} filterKey - Kaldırılacak filtrenin anahtarı
   */
  const removeFilter = (filterKey) => {
    if (filterKey === 'search') {
      searchQuery.value = ''
    } else {
      filters[filterKey] = null
    }

    // Asıl applyFilters metodunu burada çağırmıyoruz, onu kullanıcı kodu çağıracak
  }

  /**
   * Arama işlemi - applyFilters() ile uygulanacak
   */
  const searchDocuments = () => {
    // Artık sadece applyFilters() çağrıldığında filtreleme yapılacak
    // Burada bir şey yapmaya gerek yok
  }

  /**
   * Aramayı temizle
   */
  const clearSearch = () => {
    searchQuery.value = ''
    // Sadece temizleme işlemi yap, filtreleme için applyFilters çağrılmalı
  }

  /**
   * Filtre panelini aç/kapat
   */
  const toggleFilters = () => {
    showFilters.value = !showFilters.value
  }

  // Public API
  return {
    applyFilters,
    resetFilters,
    removeFilter,
    searchDocuments,
    clearSearch,
    toggleFilters,
  }
}